import React, { useState } from "react";
import { AiFillCaretDown } from "react-icons/ai";
import { NavLink } from "react-router-dom";

const NestedSideButton = ({ index, items, phone }) => {
  const [display, setDisplay] = useState(false);
  const handleDisplay = () => {
    setDisplay(!display);
  };

  return (
    <div>
      <button
        className={
          phone
            ? ""
            : "md:px-2 px-2 navBtn text-left text-white font-semibold hover:bg-white hover:text-[#000000] py-1 my-2 transition w-full ease-in-out duration-300 text-sm xl:text-md 2xl:text-lg"
        }
        key={index}
        onClick={handleDisplay}
      >
        {!phone && (
          <span className="lg:text-xl 2xl:text-2xl">{items[0][2]}</span>
        )}
        <span
          className={
            phone
              ? "ml-5 flex justify-center items-center gap-2"
              : "ml-2 xl:ml-5 flex justify-between items-center gap-2"
          }
        >
          {items[0][0]} {items[1][0].length ? <AiFillCaretDown /> : null}
        </span>
      </button>
      {display && (
        <ul tabIndex={0} className="text-white">
          {items.slice(1).map((item, index) => (
            <NavLink
              key={index}
              to={item[1]}
              className={
                phone
                  ? "flex justify-start ml-8 py-2"
                  : "navBtn justify-start ml-8"
              }
            >
              {!phone && (
                <span className={phone ? "" : "lg:text-xl 2xl:text-2xl"}>
                  {item[2]}
                </span>
              )}
              <span className={phone ? "ml-5" : "ml-2 xl:ml-2"}>{item[0]}</span>
            </NavLink>
          ))}
        </ul>
      )}
    </div>
  );
};

export default NestedSideButton;
